var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26172 1.04727C9.26172 0.584283 9.63702 0.208984 10.1 0.208984H20.1594C20.6224 0.208984 20.9977 0.584283 20.9977 1.04727C20.9977 1.51025 20.6224 1.88555 20.1594 1.88555H10.1C9.63702 1.88555 9.26172 1.51025 9.26172 1.04727Z",
    fill: "#8F96A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26172 4.40273C9.26172 3.93975 9.63702 3.56445 10.1 3.56445H20.1594C20.6224 3.56445 20.9977 3.93975 20.9977 4.40273C20.9977 4.86572 20.6224 5.24101 20.1594 5.24101H10.1C9.63702 5.24101 9.26172 4.86572 9.26172 4.40273Z",
    fill: "#8F96A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26172 11.1059C9.26172 10.6429 9.63702 10.2676 10.1 10.2676H20.1594C20.6224 10.2676 20.9977 10.6429 20.9977 11.1059C20.9977 11.5688 20.6224 11.9441 20.1594 11.9441H10.1C9.63702 11.9441 9.26172 11.5688 9.26172 11.1059Z",
    fill: "#8F96A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26172 14.4613C9.26172 13.9983 9.63702 13.623 10.1 13.623H20.1594C20.6224 13.623 20.9977 13.9983 20.9977 14.4613C20.9977 14.9243 20.6224 15.2996 20.1594 15.2996H10.1C9.63702 15.2996 9.26172 14.9243 9.26172 14.4613Z",
    fill: "#8F96A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55547 11.9441V14.459H5.07031V11.9441H2.55547ZM1.71719 10.2676H5.90859C6.37157 10.2676 6.74687 10.6429 6.74687 11.1059V15.2973C6.74687 15.7602 6.37157 16.1355 5.90859 16.1355H1.71719C1.25422 16.1355 0.878906 15.7602 0.878906 15.2973V11.1059C0.878906 10.6429 1.25422 10.2676 1.71719 10.2676Z",
    fill: "#8F96A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33962 0.454496C7.66697 0.781845 7.66697 1.31264 7.33962 1.63999L3.39375 5.58586L1.12443 3.31655C0.797065 2.98921 0.797065 2.45841 1.12443 2.13106C1.4518 1.80371 1.98257 1.80371 2.30994 2.13106L3.39375 3.21487L6.15412 0.454496C6.48147 0.127147 7.01227 0.127147 7.33962 0.454496Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTests);
export default __webpack_public_path__ + "static/media/tests.93d53bf2689182a23c4024d4c648f501.svg";
export { ForwardRef as ReactComponent };